// extracted by mini-css-extract-plugin
module.exports = {"collectionListCard":"Ln","newCollectionsImage":"Mn","groupedImagesContainer":"Nn","details":"On","nameAndMenuContainer":"Pn","cardMenuButton":"Qn","cardMenu":"Rn"};